import { userService } from "../services";
import config from "../config/config";

export const DieselRequestAction = {
  createDieselRequest,
  updateDieselRequest,
  diselstatausList,
  issuedDieselSync,
};

async function createDieselRequest(path, payload) {
  try {
    let data = {
      fuelFillRequestDTOList: [payload],
    };

    let apiEndpoint = `${
      JSON.parse(localStorage.getItem("config")).baseUrl
    }${path}`;
console.log(data)
    ////debugger;
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if ((response && response.status == 200)|| response.status ) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status = 404) {
      //     // return response;
      //     alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function updateDieselRequest(path, payload) {
console.log(path,payload)
  
  try {
    let data = {
      userId: payload.userId,
      companyId: payload.companyId,
      vehicleId: payload.vehicleId ? payload.vehicleId : null,
      requestedFuelQuantity: payload.requestedFuelQuantity
        ? +payload.requestedFuelQuantity
        : null,
      requestRemark: payload.requestRemark ? payload.requestRemark : null,
      fuelFillRequestStatus: payload.fuelFillRequestStatus
        ? payload.fuelFillRequestStatus
        : null,
      approvedFuelQuantity: payload.approvedFuelQuantity
        ? payload.approvedFuelQuantity
        : null,
      approvedRemarks: payload.approvedRemarks ? payload.approvedRemarks : null,
      rejectedRemarks: payload.rejectedRemarks ? payload.rejectedRemarks : null,
      issuedFuelQuantity: payload.issuedFuelQuantity
        ? payload.issuedFuelQuantity
        : null,
      issuedRemarks: payload.issuedRemarks ? payload.issuedRemarks : null,
      fuelFillRequestId:payload.fuelFillRequestId,
      
    };
    
    let apiEndpoint = `${
      JSON.parse(localStorage.getItem("config")).baseUrl
    }${path}`;
   console.log(data)

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status = 404) {
      //     // return response;
      //     alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function diselstatausList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.DieselRequestList
    }?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;
console.log(payload,apiEndpoint)
    ////debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response.data.data);
    if (response && response.status == 200) {
      return response.data.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status = 404) {
      //     // return response;
      //     alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function issuedDieselSync(path, payload) {
  console.log(path,payload)
    
    try {
      let data = {
        userId: payload.userId,
        companyId: payload.companyId,
        vehicleId: payload.vehicleId ? payload.vehicleId : null,
        requestedFuelQuantity: payload.requestedFuelQuantity
          ? +payload.requestedFuelQuantity
          : null,
        requestRemark: payload.requestRemark ? payload.requestRemark : null,
        fuelFillRequestStatus: payload.fuelFillRequestStatus
          ? payload.fuelFillRequestStatus
          : null,
        approvedFuelQuantity: payload.approvedFuelQuantity
          ? payload.approvedFuelQuantity
          : null,
        approvedRemarks: payload.approvedRemarks ? payload.approvedRemarks : null,
        rejectedRemarks: payload.rejectedRemarks ? payload.rejectedRemarks : null,
        issuedFuelQuantity: payload.issuedFuelQuantity
          ? payload.issuedFuelQuantity
          : null,
        issuedRemarks: payload.issuedRemarks ? payload.issuedRemarks : null,
        fuelFillRequestId:payload.fuelFillRequestId,
        fuelFillIssueVerification:payload.fuelFillIssueVerification,
        manualSyncedRemarks:payload.manualSyncedRemarks? payload.manualSyncedRemarks:null
      };
      
      let apiEndpoint = `${
        JSON.parse(localStorage.getItem("config")).baseUrl
      }${path}`;
     console.log(data)
  
      let response = await userService.post(apiEndpoint, data);
      console.log(response);
      if (response && response.status == 200) {
        return response.data;
      } else {
        console.log(response);
        alert(response.data.message);
  
        // if (response.status = 404) {
        //     // return response;
        //     alert(response.data.responseDescription);
        // } else
        // if (response.status == 401) {
        //     alert(response.data.message);
        // } else {
        //     alert(response.data.responseDescription);
        //     // return (response);
        // }
        return null;
      }
    } catch (error) {
      console.log("error", error);
      return null;
    }
  }
